import React, { memo } from 'react';
import LazyLoad from 'react-lazyload';
import { Link } from 'react-router-dom';
import DefaultProductImage from '../img/product/default-home_default.jpg';
import NumberFormatter from "./NumberFormatter";
import UseMediaQuery from "./UseMediaQuery";
import { Swiper, SwiperSlide } from 'swiper/react';
import { FreeMode, Navigation,Pagination  } from 'swiper/modules';


const ProductCard = memo(({ product, loadingProductId, handleAddToCart }) => {
    const isMobile = UseMediaQuery("(max-width: 768px)");
    
    return (
        <div className="product-pro cart">
            <Link to={`/${product.id_product}-${product.link_rewrite}.html`}>
            {!isMobile? (
                <div className="product-img-top">
                    <LazyLoad
                        height={320}
                        offset={100}
                        placeholder={
                            <div className="loading-placeholder">
                                <div className="spinner-border text-primary" role="status">
                                    <span className="visually-hidden">Loading...</span>
                                </div>
                            </div>
                        }
                    >
                        <img
                            src={product.cover === null ? DefaultProductImage : product.cover.url}
                            alt={product.name}
                        />
                    </LazyLoad>
                    {/* تصویر hover */}
                    {product.sthoverimage !== false && (
                        <LazyLoad height={320} offset={100}>
                            <img
                                className="product-hover-image"
                                src={product.sthoverimage.bySize.home_default.url}
                                alt={`${product.name} hover`}
                            />
                        </LazyLoad>
                    )}
                </div>):(
                <div className="product-img-top">
                    {product.cover === null?
                    <LazyLoad
                        height={320}
                        offset={100}
                        placeholder={
                            <div className="loading-placeholder">
                                <div className="spinner-border text-primary" role="status">
                                    <span className="visually-hidden">Loading...</span>
                                </div>
                            </div>
                        }
                    >
                        <img
                            src={product.cover === null ? DefaultProductImage : product.cover.url}
                            alt={product.name}
                        />
                    </LazyLoad>
                    :
                     <Swiper
                        slidesPerView={1}
                        modules={[FreeMode, Navigation,Pagination]}
                        lazy={{ loadPrevNext: true }}
                        pagination={{ clickable: true }}
                        className="MobileProductSwiper"
                    >
                        <SwiperSlide>
                            <img
                                src={product.cover.url}
                                alt={product.name}
                                className="swiper-lazy"
                                style={{
                                width: "162px",
                                height: "200px",
                                cursor: "pointer",
                                }}
                            />
                            <div className="swiper-lazy-preloader"></div>
                        </SwiperSlide>
                        {product.sthoverimage !== false && (
                            <SwiperSlide>
                                <img
                                    src={product.sthoverimage.bySize.home_default.url}
                                    alt={`${product.name} hover`}
                                    className="swiper-lazy"
                                    style={{
                                    width: "162px",
                                    height: "200px",
                                    cursor: "pointer",
                                    }}
                                />
                                <div className="swiper-lazy-preloader"></div>
                            </SwiperSlide>
                        )}
                    </Swiper>
                    }
                </div>
            )}
            </Link>
            <div className="card-body text-center">
                <Link
                    to={`/${product.id_product}-${product.name}.html`}
                    className="link-underline link-underline-opacity-0 card-title"
                >
                    <h5 className="card-title">{product.name}</h5>
                </Link>
                <div className="product-price">
                <span className="price"><NumberFormatter className='ms-2' amount={product.price_amount} locale ='en-us'/> ریال</span>
                </div>
                {product.quantity > 0 && (
                    <button
                        className="btn add-to-cart"
                        onClick={() => handleAddToCart(product)}
                        disabled={loadingProductId === product.id_product}
                    >
                        {loadingProductId === product.id_product && (
                            <span
                                className="spinner-border spinner-border-sm mx-1"
                                role="status"
                                aria-hidden="true"
                            ></span>
                        )}
                        افزودن به سبد خرید
                    </button>
                )}
            </div>
        </div>
    );
});

export default ProductCard;
